/**
 * Which issue date the invoice form should show when it is prefilled from an
 * existing comprobante. Three callers, three different intents:
 *
 * - EDITING A DRAFT — keep the draft's own date, even if it is in the future.
 *   A recurring schedule generates the draft on the first business day but
 *   dates it for the scheduled send, so a future date is legitimate and is
 *   often the very field the user opened the editor to change.
 * - RE-ISSUING A REJECTED CFE — keep the source date so the fixed comprobante
 *   lands in the fiscal period the sale actually belonged to ("fix the
 *   failure, don't move the sale"), but never accept a future one: DGI rejects
 *   a TmstFirma more than a day ahead, and a rejected CFE is by definition
 *   already in the past.
 * - REPLICATING an accepted comprobante — a new sale, so today.
 */
export function resolveIssueDateForPrefill(input: {
  isEditingDraft: boolean;
  isReissueOfRejected: boolean;
  /** The source comprobante's date, YYYY-MM-DD. */
  sourceDate: string | undefined;
  /** Today, YYYY-MM-DD. */
  today: string;
}): string {
  const { isEditingDraft, isReissueOfRejected, sourceDate, today } = input;
  if (isEditingDraft) {
    return sourceDate || today;
  }
  if (isReissueOfRejected && sourceDate && sourceDate <= today) {
    return sourceDate;
  }
  return today;
}
